<template>
  <form @submit.prevent>
    <div>
      <b-tabs v-if="showLibraryItems" justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
        <b-tab :active="showLibraryItems">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">{{ $t("common.library") }}</span>
          </template>
          <!--           
          <div class="pl-5 pr-5">
            <recommendation-items
              rightPanelId="sidebar-department-recommendation"
              level="department"
              libraryScopedState="department"
              organizationScopedState="organizationDepartment"
            />
          </div> -->

          <LibraryItems
            rightPanelId="sidebar-new-organizationAssetGroup"
            organizationScopedState="organizationAssetGroup"
            libraryScopedState="assetGroup"
            libraryScopedStateCategory="assetGroupCategory"
            @interceptForSetParent="interceptForSetParent"
            :query="libraryItemsQuery"
          />
        </b-tab>

        <b-tab v-if="isEditMode" :active="isEditMode">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-user"></i>
            </span>
            <span class="d-none d-sm-inline-block">
              <span v-if="isEditMode">{{ $t("common.update") }}</span>
              <span v-else>{{ $t("asset-group.new") }}</span>
            </span>
          </template>

          <sweet-input
            :isValid="!$v.form.name.$error"
            @input="$v.form.name.$touch()"
            v-model="form.name"
            type="text"
            layout="vertical"
            :placeholder="$t('asset-group.name')"
            :label="$t('asset-group.name')"
          />

          <h6 class="mt-4">{{ $t("asset-group.admin") }}</h6>

          <organization-member-select
            @onAclSelect="onAssetGroupCategoryAdminSelect"
            :permissionFilter="[
              'ORGANIZATION_ADMIN',
              'ORGANIZATION_GDPR_PRODUCT_ADMIN',
              'ORGANIZATION_KVKK_PRODUCT_ADMIN',
              'ORGANIZATION_BGYS_PRODUCT_ADMIN',
              'ORGANIZATION_DDO_PRODUCT_ADMIN',
              'ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN',
              'ORGANIZATION_RISK_ADMIN',
              'ORGANIZATION_LEGAL_ADMIN',
            ]"
            :selected="admin"
          />
          <!-- :permissionFilter="['ORGANIZATION_ADMIN']" -->

          <h6 class="mt-4">{{ $t("asset-group-category.text") }}</h6>

          <filter-select
            id="categoryFilter"
            ref="categoryFilter"
            :placeholder="$t('asset-group-category.text')"
            :multiple="false"
            @filter="onAssetGroupCategorySearch"
            @changed="onAssetGroupCategorySelect"
            :selected="form.assetGroupCategory"
          />

          <sweet-button
            @click="save()"
            type="submit"
            :loading="isUpdating"
            :disabled="isUpdating || $v.$invalid"
            variant="success"
            icon="mdi mdi-check"
            size="sm"
            buttonClass="mt-2"
          >
            {{ $t("common.save") }}
          </sweet-button>
        </b-tab>
        <b-tab :active="isEditMode">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-user"></i>
            </span>
            <span class="d-none d-sm-inline-block">
              <span v-if="isEditMode">{{ $t("common.update") }}</span>
              <span v-else>{{ $t("asset-group.new") }}</span>
            </span>
          </template>

          <sweet-input
            :isValid="!$v.form.name.$error"
            @input="$v.form.name.$touch()"
            v-model="form.name"
            type="text"
            layout="vertical"
            :placeholder="$t('asset-group.name')"
            :label="$t('asset-group.name')"
          />

          <h6 class="mt-4">{{ $t("asset-group-category.text") }}</h6>
          <filter-select
            :validation="true"
            :isValid="!$v.form.assetGroupCategory.$invalid"
            id="assetGroupCategoryFilter"
            ref="assetGroupCategoryFilter"
            :placeholder="$t('asset-group-category.text')"
            :multiple="false"
            @filter="onAssetGroupCategorySearch"
            :selected="form.assetGroupCategory"
            @changed="onAssetGroupCategorySelect"
          />

          <sweet-button
            @click="save()"
            type="submit"
            :loading="isUpdating"
            :disabled="isUpdating || $v.$invalid"
            variant="success"
            icon="mdi mdi-check"
            size="sm"
            buttonClass="mt-2"
          >
            {{ $t("common.save") }}
          </sweet-button>
        </b-tab>
      </b-tabs>
      <div v-else>
        <h2>
          <span v-if="!showLibraryItems && isEditMode">{{ entityName }} {{ $t("common.update") }}</span>
          <span v-else>{{ $t("asset-group-category.new") }}</span>
        </h2>

        <sweet-input
          :isValid="!$v.form.name.$error"
          @input="$v.form.name.$touch()"
          v-model="form.name"
          type="text"
          layout="vertical"
          :placeholder="$t('asset-group.name')"
          :label="$t('asset-group.name')"
        />

        <h6 class="mt-4">{{ $t("asset-group-category.text") }}</h6>
        <filter-select
          :validation="true"
          :isValid="!$v.form.assetGroupCategory.$invalid"
          id="assetGroupCategoryFilter"
          ref="assetGroupCategoryFilter"
          :placeholder="$t('asset-group-category.text')"
          :multiple="false"
          @filter="onAssetGroupCategorySearch"
          :selected="form.assetGroupCategory"
          @changed="onAssetGroupCategorySelect"
        />

        <h6 class="mt-4">{{ $t("asset-group.admin") }}</h6>

        <organization-member-select
          @onAclSelect="onAssetGroupCategoryAdminSelect"
          :permissionFilter="[
            'ORGANIZATION_ADMIN',
            'ORGANIZATION_GDPR_PRODUCT_ADMIN',
            'ORGANIZATION_KVKK_PRODUCT_ADMIN',
            'ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN',
            'ORGANIZATION_RISK_ADMIN',
            'ORGANIZATION_LEGAL_ADMIN',
          ]"
          :selected="admin"
        />
        <!-- :permissionFilter="['ORGANIZATION_ADMIN']"  -->

        <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
          {{ $t("common.save") }}
        </sweet-button>

        <sweet-button @click="cancel()" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="mt-2 ml-2">
          {{ $t("common.cancel") }}
        </sweet-button>
        <hr />
      </div>
    </div>
  </form>
</template>

<script>
import SweetTextarea from "@c/form/sweet-textarea";
import LibraryItems from "@cc/library-items";
import OrganizationMemberSelect from "@cc/organization-member-select";
//import RecommendationItems from "@cc/recommendation-items";

import { maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  props: { product: { type: String, required: false }, "hide-library": { type: Boolean }, closeOnSave: { type: Boolean, default: true } },
  components: {
    LibraryItems,
    SweetTextarea,
    // RecommendationItems,
    OrganizationMemberSelect,
  },
  data() {
    return {
      form: { name: undefined, admins: undefined },
      formError: undefined,
      entityName: undefined,
      adminChanged: false,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
      assetGroupCategory: {
        required,
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v || Object.keys(v).length === 0) return;

        this.form = { ...this.prepareFormForEdit(v) };
        this.entityName = this.form.name;
      },
    },
    copingEntity: {
      immediate: true,
      handler(v) {
        if (!v || Object.keys(v).length === 0) return;

        this.form = { ...this.prepareFormForEdit(v) };
        this.entityName = this.form.name;
      },
    },
    selectedAssetGroupCategory: {
      deep: true,
      immediate: true,
      handler(v) {
        this.onSelect(v);
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters["organizationAssetGroup/isUpdating"];
    },
    admin() {
      if (this.form.admins?.length > 0 && this.form.admins?.[0]?.account) {
        return this.form.admins[0].account;
      } else if (this.form._id) {
        return {
          _id: this.form.admins[0].accountId,
          name: this.form.admins[0].name,
          email: this.form.admins[0].email,
          avatar: this.form.admins[0].avatar,
        };
      }
    },
    libraryItemsQuery() {
      return this.selectedAssetGroupCategory ? { assetGroupCategory: { value: this.selectedAssetGroupCategory.libraryItem, isObject: true } } : {};
    },
    selectedAssetGroupCategory() {
      return this.$store.getters["organizationAssetGroupCategory/selectedEntity"];
    },
    editedEntity() {
      return this.$store.getters["organizationAssetGroup/editedEntity"];
    },
    editedEntity() {
      return this.$store.getters["organizationAssetGroup/editedEntity"];
    },
    copingEntity() {
      return this.$store.getters["organizationAssetGroup/copingEntity"];
    },
    isEditMode() {
      return this.$store.getters["organizationAssetGroup/isEditMode"];
    },
    showLibraryItems() {
      return !this.hideLibrary && !this.isEditMode && !this.isCoping;
    },
    isCoping() {
      return this.$store.getters["organizationAssetGroup/isCoping"];
    },
  },
  async mounted() {},
  methods: {
    async onAssetGroupCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`organizationAssetGroupCategory/paginate`, {
        options: { limit: 1000, sort: { name: "asc" } },
        query: { name: { value }, products: this.product ? { value: this.product, isObject: true } : undefined },
      });

      callback(response.data?.docs ?? []);
    },
    onAssetGroupCategorySelect(assetGroupCategory) {
      this.form = { ...this.form, assetGroupCategory };
    },
    interceptForSetParent(payload) {
      payload.assetGroupCategory = this.selectedAssetGroupCategory;
    },
    onSelect(item) {
      this.form = { ...this.form, assetGroupCategory: item };
    },
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const { data } = await this.$store.dispatch("organizationAssetGroup/save", this.form);
        this.$store.commit("organizationAssetGroup/editedEntity", data);
        this.$emit("onAssetGroupSave");
        this.adminChanged && this.$emit("onAdminChanged");
        if (this.closeOnSave) {
          this.$root.$emit("bv::toggle::collapse", "sidebar-new-asset-group");
        }
        this.form = {};
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    cancel() {
      this.$store.dispatch("organizationAssetGroup/resetForm");
    },

    onAssetGroupCategorySelect(item) {
      this.form = { ...this.form, assetGroupCategory: item };
    },

    rightPanelClosed() {},

    onAssetGroupCategoryAdminSelect(item) {
      this.form = { ...this.form, admins: [item] };
      this.adminChanged = true;
    },
    onFormSave(item) {
      this.form = { ...this.form, category: { ...item, _id: item.libraryItem } };
    },
  },
};
</script>
